import { render, staticRenderFns } from "./AddProviders.vue?vue&type=template&id=28da6fef&"
import script from "./AddProviders.vue?vue&type=script&lang=js&"
export * from "./AddProviders.vue?vue&type=script&lang=js&"
import style0 from "./AddProviders.vue?vue&type=style&index=0&id=28da6fef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports